export enum DocumentAlertSeverity {
  info,
  level1,
  level2,
  level3,
  level4,
}
